import React, { useState } from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import { CurrencyConvertion, FormatValueDecimal, calculateNetPrice } from "../../../utils/Validate";

const ProductQuantityTable = ({
    addProduct,
    variantsArray,
    productConfigVariant,
    setAddProduct,
    markDirtyState,
    currencyDetail,
    markErrorShow,
    setMarkErrorShow
}) => {
    const [commentOpen, setCommentOpen] = useState("hide");

    const handleProductChange = (e, productitem) => {
        const { name, value } = e.target;

        setAddProduct(prevProducts => {
            const nextProducts = prevProducts.map(item => {
                if (item.sid === productitem.sid) {
                    const updatedItem = { ...item, [name]: value };
                    if (name === "unitPrice" || name === "lpoQuantity") {
                        const netUnit = calculateNetPrice({
                            groupId: updatedItem.groupId,
                            productItems: [{
                                unitPrice: updatedItem.listPriceValues,
                                quantity: 1,
                                damperListPrice: updatedItem.damperListPrice,
                                actuatorListPrice: updatedItem.actuatorListPrice,
                            }],
                            margin: updatedItem.margin,
                        });
                        updatedItem.totalPrice = parseFloat(
                            (netUnit * (Number(updatedItem.lpoQuantity) || 0)).toFixed(2)
                        );
                    }
                    return updatedItem;
                }
                return item;
            });
            markDirtyState?.(nextProducts);
            return nextProducts;
        });
    };

    const handleNotesChange = (e, productitem, isClear) => {
        const index = addProduct.findIndex(i => i.sid === productitem.sid);
        if (index === -1) return;

        setAddProduct(prev => {
            const newArr = [...prev];
            newArr[index] = { ...prev[index], notes: isClear === true ? "" : e.target.value };
            markDirtyState?.(newArr);
            return newArr;
        });
    };

    // Dynamic footer totals
    const totalQuantity = (addProduct || []).reduce(
        (sum, item) => sum + (Number(item?.lpoQuantity) || 0),
        0
    );

    const grandTotalNet = (addProduct || []).reduce(
        (sum, item) => sum + (Number(item?.totalPrice) || 0),
        0
    );

    return (
        <div className="card mt-2 size-quantities-card">
            <div className="card-body">
                <div className="row h-100">
                    <div className="col-md-12 mt-1 d-flex flex-column">
                        <div className="order-size-grid-wrapper">
                            <div className="table-responsive order-size-grid-scroll">
                                <table className="table table-borderless mb-0">
                                    <TableHeader productConfigVariant={productConfigVariant} currencyDetail={currencyDetail} />
                                    <tbody>
                                        {addProduct?.map((productitem, productindex) => (
                                            <TableRow
                                                currencyDetail={currencyDetail}
                                                key={productitem?.sid ?? productindex}
                                                productitem={productitem}
                                                productindex={productindex}
                                                variantsArray={variantsArray}
                                                productConfigVariant={productConfigVariant}
                                                commentOpen={commentOpen}
                                                setCommentOpen={setCommentOpen}
                                                onProductChange={handleProductChange}
                                                onNotesChange={handleNotesChange}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-footer product-size-grid-footer">
                                <div className="footer-summary">
                                    <span className="size-summary-item">
                                        <span>Total Quantity</span>
                                        <strong>{totalQuantity}</strong>
                                    </span>

                                    <span className="size-summary-item">
                                        <span>Grand Total (Net)</span>
                                        <strong>
                                            {FormatValueDecimal(
                                                CurrencyConvertion(grandTotalNet, currencyDetail?.conversionRate, currencyDetail)
                                            )}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductQuantityTable;
